import { Stack } from '@chakra-ui/react';

import { UserProfile } from '__generated__/GQL';
import asBentoPage from 'common/bento/hoc/asBentoPage';
import Button from 'components/_core/Button';
import Header from 'features/Onboarding/components/Header';
import InformationSection, {
  InformationSectionItem,
} from 'features/Onboarding/components/InformationSection';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';
import VerifyInformationCallout from 'features/Onboarding/components/VerifyInformationCallout';
import { getCountryByCode } from 'helpers/address';

import locales from './locales';

interface AddressRecapProps {
  onContinue: () => void;
  defaultAddress: Pick<
    UserProfile,
    'city' | 'streetAddition' | 'street' | 'zip' | 'country'
  >;
}

const AddressRecap = asBentoPage<AddressRecapProps>(
  ({ defaultAddress, Layout, onContinue, onPrev }) => {
    const { city, country, street, streetAddition, zip } = defaultAddress;

    const countryFullName = getCountryByCode(country || '');

    const addressInformationItems: InformationSectionItem[] = [
      [locales.labels.street, street],
      [locales.labels.city, zip + (city ? ` ${city}` : '')],
      [locales.labels.country, countryFullName],
      [locales.labels.streetAddition, streetAddition],
    ];

    return (
      <Layout
        data-testid="personal-address-recap"
        nav={<OBNavigation onPrev={onPrev} />}
      >
        <Header title={locales.title} />

        <Stack spacing="space-40">
          <VerifyInformationCallout />
          <InformationSection
            iconName="home"
            items={addressInformationItems}
            title={locales.section}
          />
          <Button isExpanded onClick={onContinue}>
            {locales.continueCta}
          </Button>
        </Stack>
      </Layout>
    );
  },
);

export default AddressRecap;
